import React, { useState, useCallback } from "react";
import { toast } from "react-toastify";
import { useHookstate } from "@hookstate/core";
import { FB_GLOBAL_STATES } from "globalStore/globalStore";

export const useOrderData = ({ orderData = [] }) => {
  const [orderDataState, setOrderDataState] = useState([]);
  const { orderDataCounter } = useHookstate(FB_GLOBAL_STATES);
  const [newOrdersData, setNewOrdersData] = useState(0);

  const orderDataCaller = useCallback(() => {
    if (orderData && orderData.length !== 0) {
      setOrderDataState(orderData);
      orderDataCounter.set(orderDataCounter.get() + 1);
      let pendingOrdersData =
        orderDataState && orderDataState.length !== 0
          ? orderDataState.filter((order) => !order?.FulfilledDate)
          : [];
      if (pendingOrdersData.length !== 0) {
        setNewOrdersData(pendingOrdersData.length);
      }
    }
  }, [orderData]);

  return {
    orderDataState,
    newOrdersData,
    orderDataCaller,
  };
};
